'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo } from 'react';
import { getHeadlessConfig } from '../../utils/config.js';
export const SettingsContext = createContext({});
export const SettingsProvider = ({ settings, children }) => {
    const settingsValue = useMemo(() => (Object.assign(Object.assign({}, getHeadlessConfig()), settings)), [settings]);
    return _jsx(SettingsContext.Provider, { value: settingsValue, children: children });
};
